/**
 * 公司搜索组件
 */

<template>
  <div>
    <Form :label-width="80">
      <FormItem label="公司名称：">
        <Input v-model="searchValue" placeholder="请输入公司名称搜索" style="width:500px;">
        <Button slot="append" icon="ios-search" @click="searchCompanys"></Button>
        </Input>
      </FormItem>
    </Form>
    <Table style="margin-top:10px;" :columns="companyColumns" :data="companyList"></Table>
    <Page style="margin-top:10px;" ref="page" :total="totalCompanys" show-elevator show-total @on-change="changePage"></Page>
  </div>
</template>


<script>
import ajax from '../lib/userAjax'
import requestUrls from '@/lib/requestUrls'

export default {
  name: 'companyChoose',
  data() {
    return {
      searchValue: '',
      companyColumns: [
        {
          title: '公司名称',
          key: 'companyName'
        },
        {
          title: '法人',
          key: 'legalPerson',
          width: 150
        },
        {
          title: '邮箱',
          key: 'companyMail',
          width: 200
        },
        {
          title: '操作',
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.importCompany(params.row)
                  }
                }
              }, '导入'),
            ]);
          }
        }
      ],
      companyList: [],
      totalCompanys: 0
    }
  },
  created() {
    this.initCompanys()
  },
  methods: {
    async initCompanys() {
      let rep = await ajax.get(requestUrls.company.getPaged, { params: { maxResultCount: 8, skipCount: 0 } })
      if (rep.data.success) {
        this.companyList = rep.data.result.items
        this.totalCompanys = rep.data.result.totalCount
      }
    },
    searchCompanys() {
      this.getCompanys(1, this.searchValue)
    },
    async getCompanys(page, searchValue) {
      let params = {
        filter: `companyName.Contains("${searchValue}")`,
        maxResultCount: 8,
        skipCount: (page - 1) * 8
      }
      let rep = await ajax.get(requestUrls.company.getPaged, { params: params })
      if (rep.data.success) {
        this.companyList = rep.data.result.items
        this.totalCompanys = rep.data.result.totalCount
        if (page === 1) {
          this.$refs.page.currentPage = 1
        }
      }
    },
    changePage(page) {
      this.getCompanys(page, this.searchValue)
    },
    importCompany(company) {
      this.$emit('endImport', company)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
